module.exports = "<div class=\"emptystate\" >\r\n  \r\n    <img src=\"assets/images/emptystate.png\">\r\n</div>"